import { render, staticRenderFns } from "./vipQuestionBank.vue?vue&type=template&id=ab64dc4c&scoped=true&"
import script from "./vipQuestionBank.vue?vue&type=script&lang=js&"
export * from "./vipQuestionBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab64dc4c",
  null
  
)

export default component.exports